
export class PopupData {
  header: string | undefined;
  textInfo: string | undefined
  textSubmit: string | undefined
}
